import { render, staticRenderFns } from "./SvgFooter.vue?vue&type=template&id=05994c99&lang=pug&"
import script from "./SvgFooter.vue?vue&type=script&lang=js&"
export * from "./SvgFooter.vue?vue&type=script&lang=js&"
import style0 from "./SvgFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports